import { PROJECT_NAME } from 'containers/App/constants';

const CONTAINER_NAME = 'BDOSettings';

export const GET_BDO_SETTINGS = `${PROJECT_NAME}/${CONTAINER_NAME}/GET_BDO_SETTINGS`;
export const GET_BDO_SETTINGS_SUCCESS = `${PROJECT_NAME}/${CONTAINER_NAME}/GET_BDO_SETTINGS_SUCCESS`;
export const GET_BDO_SETTINGS_FAIL = `${PROJECT_NAME}/${CONTAINER_NAME}/GET_BDO_SETTINGS_FAIL`;

export const GET_BDO_SETTING = `${PROJECT_NAME}/${CONTAINER_NAME}/GET_BDO_SETTING`;
export const GET_BDO_SETTING_SUCCESS = `${PROJECT_NAME}/${CONTAINER_NAME}/GET_BDO_SETTING_SUCCESS`;
export const GET_BDO_SETTING_FAIL = `${PROJECT_NAME}/${CONTAINER_NAME}/GET_BDO_SETTING_FAIL`;

export const CREATE_BDO_SETTING = `${PROJECT_NAME}/${CONTAINER_NAME}/CREATE_BDO_SETTING`;
export const CREATE_BDO_SETTING_SUCCESS = `${PROJECT_NAME}/${CONTAINER_NAME}/CREATE_BDO_SETTING_SUCCESS`;
export const CREATE_BDO_SETTING_FAIL = `${PROJECT_NAME}/${CONTAINER_NAME}/CREATE_BDO_SETTING_FAIL`;

export const UPDATE_BDO_SETTING = `${PROJECT_NAME}/${CONTAINER_NAME}/UPDATE_BDO_SETTING`;
export const UPDATE_BDO_SETTING_SUCCESS = `${PROJECT_NAME}/${CONTAINER_NAME}/UPDATE_BDO_SETTING_SUCCESS`;
export const UPDATE_BDO_SETTING_FAIL = `${PROJECT_NAME}/${CONTAINER_NAME}/UPDATE_BDO_SETTING_FAIL`;

export const DELETE_BDO_SETTING = `${PROJECT_NAME}/${CONTAINER_NAME}/DELETE_BDO_SETTING`;
export const DELETE_BDO_SETTING_SUCCESS = `${PROJECT_NAME}/${CONTAINER_NAME}/DELETE_BDO_SETTING_SUCCESS`;
export const DELETE_BDO_SETTING_FAIL = `${PROJECT_NAME}/${CONTAINER_NAME}/DELETE_BDO_SETTING_FAIL`;

export const CLEAR_BDO_SETTINGS = `${PROJECT_NAME}/${CONTAINER_NAME}/CLEAR_BDO_SETTINGS`;
